export default __webpack_public_path__ + "static/media/flat.d59cfd9b.svg";